export default __webpack_public_path__ + "static/media/apple-cal-feature.0219aef1.png";